import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModal';
import { Body, H5 } from 'syf-component-library/ui/typography';
import { DATA_OBJECT, DATA_TYPE, MESSAGE_TYPES, PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../../../const/analytics';
import { errorHandUpImg } from '../../../../const/assets';
import MainContext from '../../../../Context';
import { t } from '../../../../strings/i18n';
import { MultiPaymentFlowWrapper } from './subcomponents';
const MultiPaymentErrorWrapper = styled(MultiPaymentFlowWrapper) `
  max-width: 65%;
  padding-top: 40px;
  text-align: center;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  img {
    width: 132px;
  }

  @media (${mediaQueries.lessThanMedium}) {
    max-width: 100%;

    & > #errorHandUp {
      width: 100px;
      height: auto;
    }
  }
`;
const MultiPaymentErrorHeader = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;
const MultiPaymentError = ({ handleClose }) => {
    const { staticHostName, triggerAnalyticsEvent } = useContext(MainContext);
    useEffect(() => {
        const eventOptionsV1 = {
            errorMessage: t('multiPaymentFlow.multiPaymentErrorTitle', {
                lng: 'en'
            }).toLowerCase(),
            pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS,
            messageType: MESSAGE_TYPES.DCH.SETTLEMENT_MULTI,
            pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.MULTI_PAYMENT,
            pageName: PAGE_NAME.MULTI_PAYMENT.FAILURE
        };
        triggerAnalyticsEvent(eventOptionsV1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(MultiPaymentErrorWrapper, { children: [_jsxs(MultiPaymentErrorHeader, { children: [_jsx("img", { alt: "Payment Error", "aria-hidden": "true", id: "errorHandUp", src: `${staticHostName}${errorHandUpImg}` }), _jsx(H5, Object.assign({ weight: "bold" }, { children: t('multiPaymentFlow.multiPaymentErrorTitle') }))] }), _jsx(Body, { children: t('multiPaymentFlow.multiPaymentErrorDescription') })] }), _jsx(ModalFooter, { dataCy: "payment-review-footer", dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: "close", dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: handleClose, primaryText: t('button.close') })] }));
};
export default MultiPaymentError;
